//服务配件归还申请
<template>
  <Page ref="page" v-loading="loading" :showReturn="!isCreate">
    <div>
      <el-form ref="form" label-width="140px" :model="params" :rules="rules">
        <div class="cm-flex-line">
          <el-form-item label="申请人：" prop="proposerCode">
            <SelectProposer
              :code.sync="params.proposerCode"
              :name.sync="params.proposerName"
              @change="proposerChange"
              :disabled="!isCreate"
            />
          </el-form-item>
          <el-form-item label="申请部门：" prop="applyDepartmentCode">
            <SelectDepartment
              ref="SelectDepartment"
              :code.sync="params.applyDepartmentCode"
              :name.sync="params.applyDepartmentName"
              disabled
            />
          </el-form-item>
          <el-form-item label="申请时间：" prop="applyTime">
            <el-date-picker
              style="width: 100%"
              v-model="params.applyTime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              :picker-options="{
                disabledDate(time) {
                  return time.getTime() > Date.now()
                }
              }"
            />
          </el-form-item>
        </div>
        <div class="cm-flex-line">
          <el-form-item label="物流单号：" prop="trackingNumber">
            <el-input
              v-model="params.trackingNumber"
              placeholder="请输入物流单号"
            ></el-input>
          </el-form-item>
          <el-form-item label="关联申请单：" prop="applyCode">
            <el-input
              v-model="params.applyCode"
              placeholder="请输入关联申请单"
            ></el-input>
          </el-form-item>
          <el-form-item label="转出仓库：" prop="outWarehouseCode">
            <SelectWarehouse
              :code.sync="params.outWarehouseCode"
              :name.sync="params.outWarehouseName"
            />
          </el-form-item>
        </div>
        <el-form-item label="用途：" prop="purpose">
          <el-input
            v-model="params.purpose"
            placeholder="请输入用途"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input
            v-model="params.remark"
            placeholder="请输入备注"
            type="textarea"
            maxlength="255"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item prop="fileList" label="附件：">
          <UploadFile
            ref="UploadFile"
            v-model="params.fileList"
            :showAccept="false"
            :limit="3"
            multiple
            :preAppendixAddr="params && params.attachmentUrl"
          />
        </el-form-item>
        <el-divider content-position="left">申请物品清单</el-divider>
        <div style="display: flex; justify-content: end; margin-bottom: 10px">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="addEvent()"
          >
            添加
          </el-button>
        </div>
        <el-table :data="params.detailUpdateInputs">
          <el-table-column header-align="center" label="料号" min-width="140">
            <template slot-scope="{ row, $index }">
              <el-tooltip
                effect="dark"
                placement="top"
                :content="params.detailUpdateInputs[$index].code"
                :disabled="!params.detailUpdateInputs[$index].code"
              >
                <div>
                  <el-form-item
                    label=""
                    label-width="0"
                    :prop="'detailUpdateInputs.' + $index + '.code'"
                    :rules="rules.code"
                  >
                    <SelectGoodsCode
                      :code.sync="params.detailUpdateInputs[$index].code"
                      :name.sync="params.detailUpdateInputs[$index].name"
                      :bserial.sync="params.detailUpdateInputs[$index].bserial"
                      @change="data => codeChange(data, $index)"
                    />
                  </el-form-item>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column header-align="center" label="名称" min-width="140">
            <template slot-scope="{ row, $index }">
              <el-tooltip
                effect="dark"
                placement="top"
                :content="params.detailUpdateInputs[$index].name"
                :disabled="!params.detailUpdateInputs[$index].name"
              >
                <div>
                  <el-form-item
                    label=""
                    label-width="0"
                    :prop="'detailUpdateInputs.' + $index + '.name'"
                    :rules="rules.name"
                  >
                    <SelectGoodsName
                      :code.sync="params.detailUpdateInputs[$index].code"
                      :name.sync="params.detailUpdateInputs[$index].name"
                      :bserial.sync="params.detailUpdateInputs[$index].bserial"
                      @change="data => codeChange(data, $index)"
                    />
                  </el-form-item>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column header-align="center" label="转出货位" width="140">
            <template slot-scope="{ row, $index }">
              <el-form-item
                label=""
                label-width="0"
                :prop="'detailUpdateInputs.' + $index + '.outPositionCode'"
                :rules="rules.outPositionCode"
              >
                <SelectGoodsLocation
                  :ref="'SelectGoodsLocationOut' + $index"
                  :code.sync="params.detailUpdateInputs[$index].outPositionCode"
                  :name.sync="params.detailUpdateInputs[$index].outPositionName"
                  :maxNum.sync="params.detailUpdateInputs[$index].maxOutNum"
                  :params="{
                    inventoryCode: params.detailUpdateInputs[$index].code,
                    warehouseCode: params.outWarehouseCode
                  }"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column header-align="center" label="主机sn" width="180">
            <template slot-scope="{ row, $index }">
              <el-form-item
                label=""
                label-width="0"
                :prop="'detailUpdateInputs.' + $index + '.completeSn'"
              >
                <el-input
                  v-model="params.detailUpdateInputs[$index].completeSn"
                  placeholder="主机sn"
                  oninput="value=value.replace(/[\u4e00-\u9fa5|\s]/g, '')"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column header-align="center" label="配件sn" width="180">
            <template slot-scope="{ row, $index }">
              <el-form-item
                label=""
                label-width="0"
                :prop="'detailUpdateInputs.' + $index + '.sn'"
                :rules="rules.sn"
              >
                <SelectSn
                  :ref="'SelectSn' + $index"
                  :code.sync="params.detailUpdateInputs[$index].sn"
                  :name.sync="params.detailUpdateInputs[$index].sn"
                  :params="{
                    cInvCode: params.detailUpdateInputs[$index].code,
                    cWhCode: params.outWarehouseCode,
                    cPosCode: params.detailUpdateInputs[$index].outPositionCode,
                    bserial: params.detailUpdateInputs[$index].bserial
                  }"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column header-align="center" label="数量" width="100">
            <template slot-scope="{ row, $index }">
              <el-form-item
                label=""
                label-width="0"
                :prop="'detailUpdateInputs.' + $index + '.num'"
                :rules="rules.num"
              >
                <el-input
                  v-model="params.detailUpdateInputs[$index].num"
                  placeholder="数量"
                  :readonly="params.detailUpdateInputs[$index].bserial"
                  @input="
                    val =>
                      (params.detailUpdateInputs[$index].num =
                        $format.fmtNumber(val))
                  "
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column header-align="center" label="客户" min-width="140">
            <template slot-scope="{ row, $index }">
              <el-tooltip
                effect="dark"
                placement="top"
                :content="params.detailUpdateInputs[$index].clientName"
                :disabled="!params.detailUpdateInputs[$index].clientName"
              >
                <div>
                  <el-form-item
                    label=""
                    label-width="0"
                    :prop="'detailUpdateInputs.' + $index + '.clientCode'"
                    :rules="rules.clientCode"
                  >
                    <SelectCustomer
                      :name.sync="params.detailUpdateInputs[$index].clientName"
                      :code.sync="params.detailUpdateInputs[$index].clientCode"
                    />
                  </el-form-item>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column header-align="center" label="故障时间" width="160">
            <template slot-scope="{ row, $index }">
              <el-form-item
                label=""
                label-width="0"
                :prop="'detailUpdateInputs.' + $index + '.malfunctionTime'"
                :rules="rules.malfunctionTime"
              >
                <el-date-picker
                  v-model="params.detailUpdateInputs[$index].malfunctionTime"
                  type="datetime"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column header-align="center" label="故障描述" min-width="140">
            <template slot-scope="{ row, $index }">
              <el-form-item
                label=""
                label-width="0"
                :prop="'detailUpdateInputs.' + $index + '.malfunctionDesc'"
              >
                <el-input
                  v-model="params.detailUpdateInputs[$index].malfunctionDesc"
                  placeholder="故障描述"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column header-align="center" label=" " width="100">
            <template slot-scope="{ row, $index }">
              <el-form-item label="" label-width="0">
                <el-button type="text" @click="deleteEvent($index)">
                  删除
                </el-button>
                <el-button type="text" @click="copyEvent($index)">
                  复制
                </el-button>
              </el-form-item>
            </template>
          </el-table-column>
          <template slot="empty">
            <div>暂无数据，请添加</div>
          </template>
        </el-table>
      </el-form>
    </div>
    <FlowableStep
      orderType="3"
      :variables="variables"
      @initNode="setNodes"
      @refresh="setAuditors"
    ></FlowableStep>
    <template slot="bottom">
      <el-button
        type="primary"
        @click="submitEvent(1)"
        style="margin-right: 10px"
      >
        提交申请
      </el-button>
      <el-button type="info" @click="submitEvent(2)">保存草稿</el-button>
    </template>
  </Page>
</template>

<script>
import FlowableStep from '@/components/FlowableStep'
import applyMixins from '../../mixins/applyMixins'
export default {
  mixins: [applyMixins],
  components: { FlowableStep },
  data() {
    return {
      rules: {
        proposerCode: [{ required: true, message: '请选择申请人' }],
        applyDepartmentCode: [{ required: true, message: '请选择申请人部门' }],
        applyTime: [{ required: true, message: '请选择申请日期' }],
        trackingNumber: [{ required: true, message: '请输入物流单号' }],
        outWarehouseCode: [{ required: true, message: '请选择转出仓库' }],
        num: [
          {
            required: true,
            validator: (rule, value, callback) => {
              let index = rule.field?.split('.')[1]
              let maxOutNum = this.params.detailUpdateInputs[index].maxOutNum
              let outCode =
                this.params.detailUpdateInputs[index].outPositionCode
              if (!value || Number(value) === 0) {
                callback('输入正整数')
              } else if (
                outCode &&
                value &&
                Number(value) > Number(maxOutNum)
              ) {
                callback(`最多${maxOutNum}`)
              } else if (value && Number(value) > 99999) {
                callback('最多99999')
              } else {
                callback()
              }
            }
          }
        ],
        code: [{ required: true, message: '请选择' }],
        name: [{ required: true, message: '请选择' }],
        clientCode: [{ required: true, message: '请选择' }],
        malfunctionTime: [{ required: true, message: '请选择' }],
        outPositionCode: [
          {
            required: false,
            validator: (rule, value, callback) => {
              try {
                let index = rule.field.split('.')[1]
                const $elem = this.$refs['SelectGoodsLocationOut' + index]
                const list = $elem?.list || []
                if (list.length > 0 && !value) {
                  callback('请选择货位')
                } else {
                  callback()
                }
              } catch (e) {
                console.log(e)
              }
            }
          }
        ],
        sn: [
          {
            required: false,
            validator: (rule, value, callback) => {
              try {
                const index = rule.field.split('.')[1]
                const { completeSn, bserial, sn } =
                  this.params.detailUpdateInputs[index]
                if (bserial && !completeSn && !sn) {
                  callback('主机sn和配件sn必填一个')
                } else {
                  callback()
                }
              } catch (e) {
                console.log(e)
              }
            }
          }
        ]
      },
      params: {
        detailUpdateInputs: [],
        auditors: {}
      },
      nodes: [],
      variables: {
        WAREHOUSE_IN: '' // 条件参数值
      }
    }
  },
  computed: {
    isCreate() {
      return this.$route.query.edit != 1
    }
  },
  mounted() {
    this.loading = true
    this.init()
    this.loading = false
  },
  methods: {
    codeChange(data, $index) {
      if (data.bserial) {
        this.$set(this.params.detailUpdateInputs[$index], 'num', 1)
      }
    },
    setNodes(nodes) {
      this.nodes = nodes
    },
    setAuditors(auditors) {
      this.params.auditors = auditors
    },
    async init() {
      try {
        const { orderCode } = this.$route.query
        const res = await this.$api.apply.partsReturnInfo({ orderCode })
        if (res) {
          const { orderResult, detailResults } = res
          let params = {
            ...orderResult,
            detailUpdateInputs: detailResults,
            auditors: {}
          }
          this.params = params
        }
      } catch (err) {
        console.log(err)
      }
    },
    addEvent() {
      this.params.detailUpdateInputs.push({
        num: '',
        code: '',
        name: '',
        bserial: false,
        clientCode: '',
        clientName: '',
        completeSn: '',
        sn: '',
        malfunctionTime: '',
        malfunctionDesc: ''
      })
    },
    deleteEvent(index) {
      this.params.detailUpdateInputs = this.params.detailUpdateInputs.filter(
        (a, i) => i !== index
      )
    },
    copyEvent(index) {
      let detail = this.params.detailUpdateInputs.find((a, i) => i === index)
      this.params.detailUpdateInputs.push({ ...detail })
    },
    submitEvent(submit) {
      if (this.loading) return
      let params = this.$utils.deepClone(this.params)
      if (params.applyTime) {
        params.applyTime = params.applyTime + ' 00:00:00'
      }
      // 以当前 fileList 为准同步附件；删光后也要清空 attachmentUrl，避免草稿旧附件被再次提交
      if (Array.isArray(params.fileList)) {
        params.attachmentUrl = params.fileList.length
          ? params.fileList
              .map(a => `${a.url}?fileName=${a.name}`)
              .join(',')
          : ''
        delete params.fileList
      }
      let detailUpdateInputs = params.detailUpdateInputs.map(a => {
        return { ...a, num: Number(a.num) }
      })
      delete params.detailUpdateInputs
      let newParams = {
        submit: submit == 1,
        detailUpdateInputs,
        updateInput: params
      }
      if (submit != 1) {
        try {
          this.loading = true
          this.$api.apply.partsReturnSave(newParams).then(result => {
            this.$message.success('草稿保存成功')
          })
        } finally {
          this.loading = false
        }
      } else {
        if (this.nodes.length) {
          let flag = true
          for (let i = 0; i < this.nodes.length; i++) {
            if (
              this.nodes[i].assigneeType == 'SELF_SELECT' &&
              this.nodes[i].userType == 2 &&
              this.nodes[i].users.length == 0 &&
              !this.params?.auditors[this.nodes[i].id]?.length
            ) {
              flag = false
              return this.$message.warning('请选择审批人后提交')
            }
          }
          console.log('flag', flag)
          if (!flag) return
        }
        this.$refs['form'].validate(async valid => {
          if (valid) {
            try {
              if (this.params.detailUpdateInputs.length === 0) {
                this.$message.warning('请至少添加一条物品清单')
                return
              }
              this.loading = true
              clearInterval(this.timeSaveFlag)
              await this.$api.apply.partsReturnSave(newParams)
              //提交成功
              this.submitSuccess('/#/partsReturnApply')
            } finally {
              this.loading = false
            }
          }
        })
      }
    },
    //申请人改变
    proposerChange(a) {
      this.$nextTick(() => {
        this.$refs.SelectDepartment?.changeEvent(a.cdepCode)
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
